import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EyecheckComponent } from 'app/EMR/eyecheck/eyecheck.component';
import { EMRService } from 'app/EMR/EMR.service';
import { HelpListPopupComponent } from 'app/EMR/Doctor/doctor-other-info/help-list-popup/help-list-popup.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-Auto_Ref_Details',
  templateUrl: './Auto_Ref_Details.component.html',
  styleUrls: ['./Auto_Ref_Details.component.scss']
})
export class Auto_Ref_DetailsComponent implements OnInit {
  destroyautoref$: Subject<boolean> = new Subject<boolean>();
  private dialated: boolean = true;
  private undialated: boolean = false;

  private selectValue: any;
  @ViewChild('autrefauto', { static: false }) private autoRef: ElementRef;
  constructor(private dialog: MatDialog,
    private emrservice: EMRService,
    ) { } 

  ngOnInit() {
   // this.getAutoRef();
    this.emrservice.share.pipe(takeUntil(this.destroyautoref$)).subscribe((x: any) => {
      if(x==6){
        setTimeout(()=>{                          
          this.autoRef.nativeElement.focus();
      }, 500);
        
      }
    });
    this.emrservice.enabledisableautorefkr =  true;
    this.emrservice.enabledisableautorefkr1=  true;
  }

  focusotherPage(type){
    this.emrservice.content.next(type);
  }

  onInputChangeauto(type:any){
    if(type == 1){
      this.emrservice.enabledisableautorefkr = false;
    }else if(type == 2){
    this.emrservice.enabledisableautorefkr1 = false;
    }
  }
  
chkvalue(value: string){
 if (value != null){
   return value;
 }
 else {
   return "?";
 }
}
getsphvalue(category: string, valuebox: string,type:any) {

  this.emrservice.ar_value_box = valuebox;
  this.emrservice.eyechkcategory = category;
 
  const dialogRef = this.dialog.open(EyecheckComponent, {
    panelClass: 'full-width-dialog',
    minHeight: '200px',
    width: '50%',
    data: {
       //category: category,
      //userid: this.authService.Loggeduser.userid
    }
  });

  dialogRef.afterClosed().pipe(takeUntil(this.destroyautoref$)).subscribe(result => {
    if(type == 1){
      this.emrservice.enabledisableautorefkr = false;
    }else if(type == 2){
    this.emrservice.enabledisableautorefkr1 = false;
    }
   
  });
}
  // Axis 
  refhelplistPOpup(type, value,typevalue:any){
    const dialogRef = this.dialog.open(HelpListPopupComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
       width: '33%',
      data: {
          typeid: type
      }
    });

     dialogRef.afterClosed().pipe(takeUntil(this.destroyautoref$)).subscribe(result => {
        if(result !=0){
          if(typevalue == 1){
            this.emrservice.enabledisableautorefkr = false;
          }else if(typevalue == 2){
          this.emrservice.enabledisableautorefkr1 = false;
          }
          this.selectValue = result;
          this.set_ar_value(value);
        }
    });
  }

  set_ar_value(row) {
    switch (row) {
      case "u_r_r1_c1": {
        this.emrservice.autoref.rs1 = this.selectValue;

        break;
      }
      case "u_r_r1_c2": {
        this.emrservice.autoref.rc1 = this.selectValue;

        break;
      }
      case "u_r_r1_c3": {
        this.emrservice.autoref.ra1 = this.selectValue;

        break;
      }
      case "u_r_r2_c1": {
        this.emrservice.autoref.rs2 = this.selectValue;

        break;
      }
      case "u_r_r2_c2": {
        this.emrservice.autoref.rc2 = this.selectValue;

        break;
      }
      case "u_r_r2_c3": {
        this.emrservice.autoref.ra2 = this.selectValue;

        break;
      }
      case "u_r_r3_c1": {
        this.emrservice.autoref.rs3 = this.selectValue;

        break;
      }
      case "u_r_r5_c1": {
        this.emrservice.autoref.rs5 = this.selectValue;

        break;
      }
      case "u_r_r3_c2": {
        this.emrservice.autoref.rc3 = this.selectValue;

        break;
      }
      case "u_r_r5_c2": {
        this.emrservice.autoref.rc5 = this.selectValue;

        break;
      }
      case "u_r_r3_c3": {
        this.emrservice.autoref.ra3 = this.selectValue;

        break;
      }
      case "u_r_r5_c3": {
        this.emrservice.autoref.ra5 = this.selectValue;

        break;
      }
      case "u_r_r4_c1": {
        this.emrservice.autoref.udrs = this.selectValue;

        break;
      }
      case "u_r_r4_c2": {
        this.emrservice.autoref.udrc = this.selectValue;

        break;
      }
      case "u_r_r4_c3": {
        this.emrservice.autoref.udra = this.selectValue;

        break;
      }

      // undilated left eye

      case "u_l_r1_c1": {
        this.emrservice.autoref.ls1 = this.selectValue;

        break;
      }
      case "u_l_r1_c2": {
        this.emrservice.autoref.lc1 = this.selectValue;

        break;
      }
      case "u_l_r1_c3": {
        this.emrservice.autoref.la1 = this.selectValue;

        break;
      }
      case "u_l_r2_c1": {
        this.emrservice.autoref.ls2 = this.selectValue;

        break;
      }
      case "u_l_r2_c2": {
        this.emrservice.autoref.lc2 = this.selectValue;

        break;
      }
      case "u_l_r2_c3": {
        this.emrservice.autoref.la2 = this.selectValue;

        break;
      }
      case "u_l_r3_c1": {
        this.emrservice.autoref.ls3 = this.selectValue;

        break;
      }
      case "u_l_r5_c1": {
        this.emrservice.autoref.ls5 = this.selectValue;

        break;
      }
      case "u_l_r3_c2": {
        this.emrservice.autoref.lc3 = this.selectValue;

        break;
      }
      case "u_l_r5_c2": {
        this.emrservice.autoref.lc5 = this.selectValue;

        break;
      }
      case "u_l_r3_c3": {
        this.emrservice.autoref.la3 = this.selectValue;

        break;
      }
      case "u_l_r5_c3": {
        this.emrservice.autoref.la5 = this.selectValue;

        break;
      }
      case "u_l_r4_c1": {
        this.emrservice.autoref.udls = this.selectValue;

        break;
      }
      case "u_l_r4_c2": {
        this.emrservice.autoref.udlc = this.selectValue;

        break;
      }
      case "u_l_r4_c3": {
        this.emrservice.autoref.udla = this.selectValue;

        break;
      }

      // dialated right

      case "d_r_r1_c1": {
        this.emrservice.autoref.drs1 = this.selectValue;

        break;
      }
      case "d_r_r1_c2": {
        this.emrservice.autoref.drc1 = this.selectValue;

        break;
      }
      case "d_r_r1_c3": {
        this.emrservice.autoref.dra1 = this.selectValue;

        break;
      }
      case "d_r_r2_c1": {
        this.emrservice.autoref.drs2 = this.selectValue;

        break;
      }
      case "d_r_r2_c2": {
        this.emrservice.autoref.drc2 = this.selectValue;

        break;
      }
      case "d_r_r2_c3": {
        this.emrservice.autoref.dra2 = this.selectValue;

        break;
      }
      case "d_r_r3_c1": {
        this.emrservice.autoref.drs3 = this.selectValue;

        break;
      }
    
      case "d_r_r3_c2": {
        this.emrservice.autoref.drc3 = this.selectValue;

        break;
      }
    
      case "d_r_r3_c3": {
        this.emrservice.autoref.dra3 = this.selectValue;

        break;
      }
      case "d_r_r5_c3": {
        this.emrservice.autoref.dra5 = this.selectValue;

        break;
      }
      case "d_r_r4_c1": {
        this.emrservice.autoref.drs = this.selectValue;

        break;
      }
      case "d_r_r4_c2": {
        this.emrservice.autoref.drc = this.selectValue;

        break;
      }
      case "d_r_r4_c3": {
        this.emrservice.autoref.dra = this.selectValue;

        break;
      }

      // dilated left eye
      case "d_l_r1_c1": {
        this.emrservice.autoref.dls1 = this.selectValue;

        break;
      }
      case "d_l_r1_c2": {
        this.emrservice.autoref.dlc1 = this.selectValue;

        break;
      }
      case "d_l_r1_c3": {
        this.emrservice.autoref.dla1 = this.selectValue;

        break;
      }
      case "d_l_r2_c1": {
        this.emrservice.autoref.dls2 = this.selectValue;

        break;
      }
      case "d_l_r2_c2": {
        this.emrservice.autoref.dlc2 = this.selectValue;

        break;
      }
      case "d_l_r2_c3": {
        this.emrservice.autoref.dla2 = this.selectValue;

        break;
      }
      case "d_l_r3_c1": {
        this.emrservice.autoref.dls3 = this.selectValue;

        break;
      }
      case "d_l_r5_c1": {
        this.emrservice.autoref.dls5 = this.selectValue;

        break;
      }
      case "d_l_r3_c2": {
        this.emrservice.autoref.dlc3 = this.selectValue;

        break;
      }
      case "d_l_r5_c2": {
        this.emrservice.autoref.dlc5 = this.selectValue;

        break;
      }
      case "d_l_r3_c3": {
        this.emrservice.autoref.dla3 = this.selectValue;

        break;
      }
      case "d_l_r5_c3": {
        this.emrservice.autoref.dla5 = this.selectValue;

        break;
      }
      case "d_l_r4_c1": {
        this.emrservice.autoref.dls = this.selectValue;

        break;
      }
      case "d_l_r4_c2": {
        this.emrservice.autoref.dlc = this.selectValue;

        break;
      }
      case "d_l_r4_c3": {
        this.emrservice.autoref.dla = this.selectValue;

        break;
      }
      case "d_l_r5_c3": {
        this.emrservice.autoref.dla5 = this.selectValue;

        break;
      }
    }
    this.selectValue = '';
  }
 
  ngOnDestroy():void {
    this.destroyautoref$.next(true);
    this.destroyautoref$.unsubscribe();
  }

}
